import Stack from "@mui/material/Stack";
import NoSelectionPrompt from "../components/NoSelectionPrompt.tsx";
import Panel from "../components/Panel.tsx";
import { useTenant } from "../contexts/TenantContext.tsx";
import CurrencyPage from "./settings/tenant/CurrencyPage.tsx";
import IcpPage from "./settings/tenant/IcpPage.tsx";
import LogoPage from "./settings/tenant/LogoPage.tsx";
import RequiredPropertiesPage from "./settings/tenant/RequiredPropertiesPage.tsx";
import PageHeader from "../components/PageHeader.tsx";

function SettingsPage() {
  const { selectedTenantId, selectedTenant } = useTenant();

  if (!selectedTenantId) {
    return (
      <>
        <PageHeader title="Settings" />
        <NoSelectionPrompt kind="tenant" />
      </>
    );
  }

  const tenantName = selectedTenant?.name ?? "this tenant";

  return (
    <>
      <PageHeader
        title="Settings"
        description={`The logo, company profile, currency and required properties of ${tenantName}`}
      />

      <Stack spacing={3}>
        <Panel title="Logo" subtitle={`Shown next to ${tenantName} across the app`}>
          <LogoPage />
        </Panel>

        <Panel
          title="Company profile"
          subtitle="Signal scoring and the research agents read this profile. New prospect orders start from it, and the prospecting agent uses it wherever an order leaves a field empty."
        >
          <IcpPage />
        </Panel>

        <Panel
          title="Currency"
          subtitle="Revenue and operating result are shown, filtered and exported to your CRM in this currency. Companies report in their own currency (Swedish in SEK, Finnish in EUR); their figures are converted at current ECB reference rates."
        >
          <CurrencyPage />
        </Panel>

        <Panel
          title="Required properties"
          subtitle="Companies and contacts missing these fields are flagged as incomplete. A collection cannot be exported (CSV or CRM) until every entry is complete or disqualified."
        >
          <RequiredPropertiesPage />
        </Panel>
      </Stack>
    </>
  );
}

export default SettingsPage;
